import React,{useState, useEffect} from 'react';
import axios from 'axios';
import {databaseUrl} from '../../server/server.js';
import { useLocation } from 'react-router-dom';
import { Button } from '@mui/material';
import axiosInstance from '../../server/axios.js';

const DepositcompanyList = () => {

    useEffect(()=>{GetCompanyList()},[]);
    const GetCompanyList = async () => {
        const companyList = await axiosInstance.get('/company/companylist');
        console.log(companyList.data);
    }
/*
    const [notaccess, setNotaccess] = useState('');
    const sendChangedDate = () => {
        const changDate = due_date;
        axios.get(`${databaseUrl}/orderboard/changedate?id=${number}&chdate=${deliverydate}`,{
            headers: {Authorization:`Bearer ${access}`},
        }).then((response)=>{
            window.open('','_self').close(); 
        })
    }
*/
    return (
        <div>DepositcompanyList</div>
    )
}
export default DepositcompanyList;
